export const UPDATE_COMMENT_LIKES = 'UPDATE_COMMENT_LIKES'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const ADD_COMMENT = 'ADD_COMMENT'
export const ADD_COMMENT_REPLY = 'ADD_COMMENT_REPLY'
export const ADD_COMMENT_REPLIES = 'ADD_COMMENT_REPLIES'
